module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "sidebar",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "base-five border-bottom",
    attrs: {
      "id": "title"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        params: {
          language: _vm.language
        }
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "172",
      "height": "23.1",
      "viewBox": "0 0 172 23.1"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "a",
      "d": "M.5.2h171.1v22.6H.5z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a",
      "overflow": "visible"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M159.7 14.7c0-2.3.5-4.9 3-4.9 2.3 0 3 2.2 3 4.9 0 2.2-.5 4.9-3 4.9-.5 0-1.6-.1-2.2-1.2-.7-1.2-.8-2.7-.8-3.7m-6 0c0 1.9.4 4.2 2.2 5.9 1.5 1.4 3.7 2.3 7.1 2.3 3.2 0 5.1-1 6.4-2.2 1.6-1.6 2.2-3.9 2.2-6.1 0-5.5-3.9-8-8.9-8-6.1-.1-9 3.3-9 8.1m-8.3 7.8h5.8V7h-5.8v15.5zm0-18.1h5.9V.3h-5.9v4.1zm-11.9 15c-2.6 0-2.9-3.2-2.9-4.6 0-1.4.3-4.7 2.9-4.7 2 0 2.9 2 2.9 4.6.1 2.6-.8 4.7-2.9 4.7M136.4.2v8.6c-1-1.1-2.1-2.2-4.7-2.2-1.9 0-3.7.6-5.1 2.1-1 1.1-1.9 2.7-1.9 6 0 3.8 1.5 8.1 6.8 8.1 3.4 0 4.6-1.8 5.2-2.6l.1 2.3h5.5c-.1-1.3-.2-2.6-.2-3.8V.2h-5.7zM105.9 7v8.7c0 3 .3 7 5.7 7 1.4 0 3.3-.2 4.9-2.7l.1 2.4h5.7c0-1.2 0-1.4-.1-2.7V7h-5.8v9c0 .9 0 3.1-2.4 3.1-2.3 0-2.3-2.2-2.3-3V7h-5.8zm-5.7.1V2.5l-5.6 2.2v2.4h-3v3.7h2.9v7.4c0 3 .9 4.5 5.5 4.5 2 0 3-.2 3.8-.3v-3.6c-.7.1-1 .1-1.4.1-2.2 0-2.2-.9-2.2-2.8v-5.4h3.7V7.1h-3.7zM75.6 17.4c-.1 5 4.5 5.4 7.6 5.4 1.4 0 7.4 0 7.4-5.2 0-3-2.2-3.8-3.6-4.2l-4.1-1.1c-.9-.2-1.6-.6-1.6-1.5 0-1 .8-1.4 1.7-1.4.9 0 1.4.3 1.6.8.2.5.2 1 .2 1.5h5.5c-.2-4.3-3.7-5.2-7-5.2-2.3 0-4.1.4-5.5 1.3-1 .7-1.8 2-1.8 3.5 0 3.2 2.8 3.9 3.8 4.2l3.1.9c1.3.3 2.2.6 2.2 1.7 0 .7-.4 1.6-1.8 1.6-1 0-1.5-.5-1.7-1-.2-.5-.2-1.1-.2-1.4h-5.8zM64 3.3l4.1 10.9h-8.4L64 3.3zM53.2 22.5h3.2l2.4-5.8h10.3l2.4 5.8h3.4L65.9.3h-3.3l-9.4 22.2zm-4.8 0V2.9h7.4V.2H37.9v2.6h7.4v19.6h3.1zM29.6 3.3l4.1 10.9h-8.4l4.3-10.9zM18.8 22.5H22l2.4-5.8h10.3l2.4 5.8h3.4L31.5.3h-3.3l-9.4 22.2zM3.6 2.8h3.7c2.7 0 4.5.4 5.9 1.9 2.1 2.3 2.2 6.1 2.2 6.9 0 1.3-.1 4.9-2.9 7-1.5 1.1-3.7 1.2-5.8 1.2h-3v-17zM.5 22.5h6.2c3.3 0 6 0 8.2-1.8 1.7-1.4 3.7-4.3 3.7-9.1 0-3-.8-6.1-2.7-8.4C13.4.3 9.9.3 6.9.3H.5v22.2z"
    }
  })])]), _vm._v(" "), (_vm.screenSize.mobile === true) ? _c('div', {
    staticClass: "three-bar",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('div', {
    staticClass: "part"
  }), _vm._v(" "), _c('div', {
    staticClass: "part"
  }), _vm._v(" "), _c('div', {
    staticClass: "part"
  })]) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === true && _vm.mobileMenuActive) ? _c('div', {
    staticClass: "mobile-menu"
  }, [_c('dsMenu', {
    attrs: {
      "language": _vm.language
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('div', {
    staticClass: "small-blog"
  }, [_c('div', {
    staticClass: "blog-header base-five border-bottom"
  }, [_c('div', {
    staticClass: "menu-item small-text"
  }, [(_vm.language === "nl") ? _c('span', {
    staticClass: "small-text"
  }, [_c('strong', [_vm._v("over DATAstudio")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
    staticClass: "small-text"
  }, [_c('strong', [_vm._v("About DATAstudio")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "blog-content secondary-color border-bottom"
  }, [(_vm.language === "nl") ? _c('div', {
    staticClass: "blog-content-inner"
  }, [_vm._v("\n        Er wordt nogal wat info verzameld over inwoners en de buurt waarin ze wonen, door gemeente en door bedrijven: allemaal data. Die data en datatechnologie worden ingezet om een stad slim te organiseren. Maar kun je ze ook gebruiken om als inwoners samen tot een fijnere buurt te komen?\n      ")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "blog-content-inner"
  }, [_vm._v("\n        Cities and private companies collect all sorts of information on people and the neighbourhoods they live in. That’s data. Data and data technology are used to organise cities in smarter ways. But can residents also use them to make their neighbourhood a nicer place?\n      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'overons',
        params: {
          language: 'nl'
        }
      }
    }
  }, [_vm._v("Lees meer")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false && _vm.language === "nl" && _vm.loaded.pages) ? _c('div', {
    staticClass: "about-container padding-top roman",
    domProps: {
      "innerHTML": _vm._s(_vm.overons.acf.short_text_nl)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false && _vm.language === "en" && _vm.loaded.pages) ? _c('div', {
    staticClass: "about-container padding-top roman",
    domProps: {
      "innerHTML": _vm._s(_vm.overons.acf.short_text_en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('a', {
    staticClass: "small-hni-logo",
    attrs: {
      "href": "http://hetnieuweinstituut.nl/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/hni.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('a', {
    staticClass: "small-data-studio-logo",
    attrs: {
      "href": "http://datastudio-eindhoven.nl"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79efb49a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsSideBar.vue
// module id = 221
// module chunks = 2